import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import Select from 'react-select';
import Modal from 'react-responsive-modal';

const required = value => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          Este campo es obligatorio!
        </div>
      );
    }
  };

export class Ver_edit_whatsapp_campaign extends Component {
    constructor(props) {
        super(props);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.onChangeCampaignName = this.onChangeCampaignName.bind(this);
        this.onChangeCampaignMessage = this.onChangeCampaignMessage.bind(this);
        this.handleClusterChange = this.handleClusterChange.bind(this);
        this.handleCollectionChange = this.handleCollectionChange.bind(this);
        this.handleBannerChange = this.handleBannerChange.bind(this);
        this.onChangeDiscountPercentage = this.onChangeDiscountPercentage.bind(this);
        this.onChangeScheduledDate = this.onChangeScheduledDate.bind(this);
        this.onChangeActiveFrom = this.onChangeActiveFrom.bind(this);
        this.onChangeActiveUntil = this.onChangeActiveUntil.bind(this);
        this.onChangeMaxUsesPerUser = this.onChangeMaxUsesPerUser.bind(this);
        this.onChangeStatus = this.onChangeStatus.bind(this);

        this.state = {
            campaign_name: "",
            whatsapp_message: "",
            selectedCluster: null,
            selectedCollection: null,
            selectedBanner: null,
            discount_percentage: "",
            campaign_status: "DRAFT",
            scheduled_date: "",
            active_from: "",
            active_until: "",
            max_uses_per_user: "",
            clusters: [],
            collections: [],
            banners: [],
            errors: {},
            loading: false,
            campaignData: null,
            openImageModal: false,
        }
    }

    componentWillMount() {
        this.getDataCampaign();
        this.getDataClusters();
        this.getDataCollections();
        this.getDataBanners();
    }

    getDataClusters(){
        var user = AuthService.getCurrentUser();
        ApiService.getCustomerClusters(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const clusters = res.data.map(function(row) {
                        return {
                            value: row.id,
                            label: row.cluster_name
                        }
                    })
                    this.setState({ clusters: clusters });
                }
            },
            error => {
            }
        );
    }

    getDataCampaign(){
        var user = AuthService.getCurrentUser();
        let id_campaign = this.props.match.params.id;
        ApiService.getWhatsappCampaignDetails(user.token, id_campaign).then(
            (res) => {
                if(res && res.status === 'success')
                {
                    const campaign = res.data;

                    // Formatear fecha para input datetime-local
                    let formattedDate = "";
                    if(campaign.scheduled_date) {
                        const date = new Date(campaign.scheduled_date);
                        formattedDate = date.toISOString().slice(0, 10);
                    }

                    let formattedActiveFrom = "";
                    if(campaign.active_from) {
                        const date = new Date(campaign.active_from);
                        formattedActiveFrom = date.toISOString().slice(0, 10);
                    }

                    let formattedActiveUntil = "";
                    if(campaign.active_until) {
                        const date = new Date(campaign.active_until);
                        formattedActiveUntil = date.toISOString().slice(0, 10);
                    }

                    this.setState({
                        campaign_name: campaign.campaign_name,
                        whatsapp_message: campaign.whatsapp_message,
                        campaign_status: campaign.campaign_status,
                        scheduled_date: formattedDate,
                        active_from: formattedActiveFrom,
                        active_until: formattedActiveUntil,
                        max_uses_per_user: campaign.max_uses_per_user || "",
                        discount_percentage: campaign.discount_percentage || "",
                        campaignData: campaign,
                        selectedCluster: campaign.Cluster ? {
                            value: campaign.Cluster.id,
                            label: campaign.Cluster.cluster_name
                        } : null,
                        selectedCollection: campaign.Collection ? {
                            value: campaign.Collection.id,
                            label: campaign.Collection.collection_name
                        } : null,
                        selectedBanner: campaign.Banner ? {
                            value: campaign.Banner.id,
                            label: campaign.Banner.name || `Banner ${campaign.Banner.id}`,
                            image: campaign.Banner.image
                        } : null
                    });
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
              toast.error("Error al cargar la campaña");
            }
          );
    }

    onChangeCampaignName(e) {
        this.setState({
            campaign_name: e.target.value
        });
    }

    onChangeCampaignMessage(e) {
        this.setState({
            whatsapp_message: e.target.value
        });
    }

    getDataCollections(){
        var user = AuthService.getCurrentUser();
        ApiService.getProductCollections(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const collections = res.data
                        .filter(row => row.collection_status === 'ACTIVO')
                        .map(function(row) {
                            return {
                                value: row.id,
                                label: row.collection_name
                            }
                        });
                    this.setState({ collections: collections });
                }
            },
            error => {
            }
        );
    }

    getDataBanners(){
        var user = AuthService.getCurrentUser();
        ApiService.getDataBanners(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const banners = res.data.map(function(row) {
                        return {
                            value: row.id,
                            label: row.name || `Banner ${row.id}`,
                            image: row.image
                        }
                    });
                    this.setState({ banners: banners });
                }
            },
            error => {
            }
        );
    }

    handleClusterChange = (selectedOption) => {
        this.setState({ selectedCluster: selectedOption });
    };

    handleCollectionChange = (selectedOption) => {
        this.setState({ selectedCollection: selectedOption });
    };

    handleBannerChange = (selectedOption) => {
        this.setState({ selectedBanner: selectedOption });
    };

    onChangeDiscountPercentage(e) {
        this.setState({
            discount_percentage: e.target.value
        });
    }

    onChangeScheduledDate(e) {
        this.setState({
            scheduled_date: e.target.value
        });
    }

    onChangeActiveFrom(e) {
        this.setState({
            active_from: e.target.value
        });
    }

    onChangeActiveUntil(e) {
        this.setState({
            active_until: e.target.value
        });
    }

    onChangeMaxUsesPerUser(e) {
        this.setState({
            max_uses_per_user: e.target.value
        });
    }

    onChangeStatus(e) {
        this.setState({
            campaign_status: e.target.value
        });
    }

    onOpenImageModal = () => {
        this.setState({ openImageModal: true });
    };

    onCloseImageModal = () => {
        this.setState({ openImageModal: false });
    };

    handleUpdate(e) {
        e.preventDefault();

        this.form.validateAll();

        if (this.checkBtn.context._errors.length === 0) {
            if (!this.state.selectedCluster) {
                toast.error("Por favor selecciona un grupo de clientes.");
                return;
            }

            if (!this.state.active_from) {
                toast.error("Por favor selecciona la fecha de inicio de la campaña.");
                return;
            }

            if (!this.state.active_until) {
                toast.error("Por favor selecciona la fecha de fin de la campaña.");
                return;
            }

            // Validar que la fecha de fin sea posterior a la fecha de inicio
            if (this.state.active_from && this.state.active_until) {
                const dateFrom = new Date(this.state.active_from);
                const dateUntil = new Date(this.state.active_until);
                if (dateUntil <= dateFrom) {
                    toast.error("La fecha de fin debe ser posterior a la fecha de inicio.");
                    return;
                }
            }

            this.setState({
                message: "",
                loading: true
            });

            var user = AuthService.getCurrentUser();
            let id_campaign = this.props.match.params.id;
            let data_campaign = {
                'id_campaign': id_campaign,
                'campaign_name': this.state.campaign_name,
                'whatsapp_message': this.state.whatsapp_message,
                'id_cluster': this.state.selectedCluster ? this.state.selectedCluster.value : null,
                'id_collection': this.state.selectedCollection ? this.state.selectedCollection.value : null,
                'discount_percentage': this.state.discount_percentage || null,
                'id_banner': this.state.selectedBanner ? this.state.selectedBanner.value : null,
                'campaign_status': this.state.campaign_status,
                'scheduled_date': this.state.scheduled_date || null,
                'active_from': this.state.active_from || null,
                'active_until': this.state.active_until || null,
                'max_uses_per_user': this.state.max_uses_per_user || null,
            }

            ApiService.putWhatsappCampaign(user.token, data_campaign).then(
            (res) => {
                if(res){
                    if(res.status == 'success')
                    {
                        this.props.history.push("/whatsapp-campaigns");
                        toast.success("Campaña actualizada!");
                    }
                    else
                    {
                        toast.error(res.message || "Error al actualizar la campaña");
                        this.setState({
                            loading: false
                        });
                    }
                }else{
                    toast.error("Error al procesar la solicitud");
                    this.setState({
                        loading: false
                    });
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();

              this.setState({
                loading: false
              });

              toast.error(resMessage);
            }
          );
        }
    }

    render() {
        const isDisabled = this.state.campaignData && this.state.campaignData.campaign_status === 'ENVIADA';

        return (
            <Fragment>
                <Breadcrumb title="Editar Campaña de WhatsApp" parent="Promociones" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Editar Campaña de WhatsApp</h5>
                                </div>
                                <div className="card-body">
                                {isDisabled && (
                                    <div className="alert alert-warning" role="alert">
                                        Esta campaña ya fue enviada y no puede ser editada.
                                    </div>
                                )}
                                <Form
                                    onSubmit={this.handleUpdate}
                                    ref={c => {
                                        this.form = c;
                                    }}
                                >
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Nombre de la Campaña</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                name="campaign_name"
                                                placeholder="Ej: Campaña Navideña 2025"
                                                value={this.state.campaign_name}
                                                onChange={this.onChangeCampaignName}
                                                validations={[required]}
                                                disabled={isDisabled}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Mensaje de WhatsApp</label>
                                        <div className="col-md-7">
                                            <textarea
                                                className="form-control"
                                                name="whatsapp_message"
                                                rows="4"
                                                placeholder="Ej: ¡Tenemos algo increíble para ti hoy! Ingresa a la web y entérate de nuestras promociones exclusivas."
                                                value={this.state.whatsapp_message}
                                                onChange={this.onChangeCampaignMessage}
                                                required
                                                disabled={isDisabled}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Grupo de Clientes</label>
                                        <div className="col-md-7">
                                            <Select
                                                value={this.state.selectedCluster}
                                                onChange={this.handleClusterChange}
                                                options={this.state.clusters}
                                                placeholder="Selecciona un grupo de clientes..."
                                                isClearable={true}
                                                isDisabled={isDisabled}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Colección de Productos</label>
                                        <div className="col-md-7">
                                            <Select
                                                value={this.state.selectedCollection}
                                                onChange={this.handleCollectionChange}
                                                options={this.state.collections}
                                                placeholder="Selecciona una colección de productos..."
                                                isClearable={true}
                                                isDisabled={isDisabled}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. Selecciona la colección de productos para esta campaña.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Porcentaje de Descuento</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="number"
                                                className="form-control"
                                                name="discount_percentage"
                                                placeholder="Ej: 10"
                                                min="0"
                                                max="100"
                                                step="0.01"
                                                value={this.state.discount_percentage}
                                                onChange={this.onChangeDiscountPercentage}
                                                disabled={isDisabled}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. Ingresa el porcentaje de descuento (0-100).
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Banner</label>
                                        <div className="col-md-7">
                                            <Select
                                                value={this.state.selectedBanner}
                                                onChange={this.handleBannerChange}
                                                options={this.state.banners}
                                                placeholder="Selecciona un banner..."
                                                isClearable={true}
                                                isDisabled={isDisabled}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. Banner que aparecerá cuando el cliente entre al link de la campaña.
                                            </small>
                                            {this.state.selectedBanner && this.state.selectedBanner.image && (
                                                <div className="mt-3">
                                                    <img
                                                        src={`${process.env.REACT_APP_URL_FILES}images/banners/${this.state.selectedBanner.image}`}
                                                        alt="Banner preview"
                                                        style={{
                                                            width: '100px',
                                                            height: '100px',
                                                            objectFit: 'cover',
                                                            cursor: 'pointer',
                                                            border: '2px solid #ddd',
                                                            borderRadius: '4px'
                                                        }}
                                                        onClick={this.onOpenImageModal}
                                                        title="Clic para ver imagen completa"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Fecha Programada</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="date"
                                                className="form-control"
                                                name="scheduled_date"
                                                value={this.state.scheduled_date}
                                                onChange={this.onChangeScheduledDate}
                                                disabled={isDisabled}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. Fecha y hora en que se enviará automáticamente la campaña.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Fecha de Inicio</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="date"
                                                className="form-control"
                                                name="active_from"
                                                value={this.state.active_from}
                                                onChange={this.onChangeActiveFrom}
                                                disabled={isDisabled}
                                            />
                                            <small className="form-text text-muted">
                                                Fecha desde la cual la campaña estará activa.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Fecha de Fin</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="date"
                                                className="form-control"
                                                name="active_until"
                                                value={this.state.active_until}
                                                onChange={this.onChangeActiveUntil}
                                                disabled={isDisabled}
                                            />
                                            <small className="form-text text-muted">
                                                Fecha hasta la cual la campaña estará activa.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Usos Máximos por Usuario</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="number"
                                                className="form-control"
                                                name="max_uses_per_user"
                                                placeholder="Ej: 3"
                                                min="1"
                                                value={this.state.max_uses_per_user}
                                                onChange={this.onChangeMaxUsesPerUser}
                                                disabled={isDisabled}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. Cantidad máxima de veces que un usuario puede usar esta campaña.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Estado</label>
                                        <div className="col-md-7">
                                            <select
                                                name="campaign_status"
                                                className="form-control"
                                                value={this.state.campaign_status}
                                                onChange={this.onChangeStatus}
                                                disabled={isDisabled}
                                            >
                                                <option value="BORRADOR">BORRADOR</option>
                                                <option value="PROGRAMADA">PROGRAMADA</option>
                                                <option value="ENVIADA">ENVIADA</option>
                                                <option value="CANCELADA">CANCELADA</option>
                                            </select>
                                        </div>
                                    </div>
                                    {!isDisabled && (
                                        <div className="pull-right">
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                                disabled={this.state.loading}
                                            >
                                                {this.state.loading && (
                                                <span className="spinner-border spinner-border-sm"></span>
                                                )}
                                                Actualizar
                                            </button>
                                        </div>
                                    )}
                                    <CheckButton
                                        style={{ display: "none" }}
                                        ref={c => {
                                        this.checkBtn = c;
                                        }}
                                    />
                                </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />

                <Modal
                    open={this.state.openImageModal}
                    onClose={this.onCloseImageModal}
                    center
                    styles={{
                        modal: {
                            maxWidth: '90%',
                            width: 'auto'
                        }
                    }}
                >
                    <div style={{ padding: '20px' }}>
                        <h5 className="mb-3">Vista Previa del Banner</h5>
                        {this.state.selectedBanner && this.state.selectedBanner.image && (
                            <img
                                src={`${process.env.REACT_APP_URL_FILES}images/banners/${this.state.selectedBanner.image}`}
                                alt="Banner completo"
                                style={{
                                    maxWidth: '100%',
                                    height: 'auto',
                                    display: 'block'
                                }}
                            />
                        )}
                    </div>
                </Modal>
            </Fragment>
        )
    }
}

export default Ver_edit_whatsapp_campaign
